import FilterStatusInfoModalContainer from './containers/FilterStatusInfoModalContainer'

export default FilterStatusInfoModalContainer
